import React, { Component } from "react";
import keyCodes from "../commonjs/keyCodes";
import keyListener from '../commonjs/keyListener';
import $ from 'jquery';
let _Gitv = window.gitv;
_Gitv && _Gitv.onInit();

/*
 * @Author: Sunshine 
 * @Date: 2023-06-07 18:05:15 
 * @Last Modified by: Sunshine
 * @Last Modified time: 2023-06-08 09:19:17
 */

export default class ScrollView extends Component {
   
    constructor(props) {
        super(props);
        this.state = { showMask: false }
    }

    scrollBar;
    //滚动条高度
    scrollbarHeight;
    //展示内容的总高度
    scrollHeight;
    //滚动条的初始化位置
    scrollBarTop;
    componentDidMount() {
        _Gitv && _Gitv.setExitOnNextBack("true");

        this.scrollBar = document.getElementById("scrollbar");
        window.addEventListener("scroll", this.handleEventListener);

        keyListener.set(this.handleKeyDown);

        this.scrollBarTop = this.getTop();

        this.scrollHeight = document.documentElement.scrollHeight;
        //动态计算并更新滚动条高度，公式为滚动条高度 = 视口高度 / （内容高度 + 视口高度） X 滚动区域高度
        this.scrollbarHeight = window.innerHeight / (this.scrollHeight + window.innerHeight) * (window.innerHeight - this.scrollBarTop)
        console.log("scrollHeight:" + this.scrollbarHeight + ",clientHeight:" + window.height)
        $(".scrollbar").animate({ height: this.scrollbarHeight }, 100);
        $(".scrollbar").fadeOut();

    }
    handleEventListener = (e) => {
        let top = e.srcElement.documentElement.scrollTop
        if (top <= 0 && this.state.showMask) {
            this.setState(prevState => ({ ...prevState, showMask: false }))
        } else if (top > 20 && !this.state.showMask) {
            this.setState(prevState => ({ ...prevState, showMask: true }))
        }
    }

    componentWillUnmount() {
        this.timer && clearTimeout(this.timer);
        window.removeEventListener("scroll", this.handleEventListener);
    }

    scrollY = 0
    //是否展示自定义滚动栏
    showScroller = false;
    timer;
    handleKeyDown = (keyCode) => {
        if (keyCode == keyCodes.down) {
            //按下键
            this.scrollY -= 80;
            this.bd = window.innerHeight;

            if (this.scrollY + this.scrollHeight < this.bd) {
                this.scrollY = this.bd - this.scrollHeight;
            }

            $(".scrollBox").animate({ top: this.scrollY }, 100);
            let y = -this.scrollY * (this.bd - this.scrollbarHeight - this.scrollBarTop) / (this.scrollHeight) + this.scrollBarTop;
            console.log("down :scrollY=" + this.scrollY + ",top=" + y + ",clientHeight=" + this.scrollHeight);

            $(".scrollbar").animate({ top: y }, 100, () => {
                let top = this.getTop();
                console.log("top:" + top + ",scrollTop:" + this.scrollBarTop + ",showMask:" + this.state.showMask)
                if (!this.state.showMask) {
                    this.setState(prevState => ({ ...prevState, showMask: true, isTop: false }));
                }
            });

            if (!this.showScroller) {
                $(".scrollbar").fadeIn(50);
                this.showScroller = true;
            }
            clearTimeout(this.timer)
            this.timer = setTimeout(() => {
                $(".scrollbar").fadeOut(500);
                this.showScroller = false;
            }, 2500);

        } else if (keyCode == keyCodes.up) {
            //按上键
            this.scrollY += 80;
            if (this.scrollY > 0) {
                this.scrollY = 0;
            }

            if (!this.showScroller) {
                $(".scrollbar").fadeIn(50)
                this.showScroller = true;
            }

            clearTimeout(this.timer)
            this.timer = setTimeout(() => {
                $(".scrollbar").fadeOut(500);
                this.showScroller = false;
            }, 2500);

            const y = -this.scrollY * (this.bd - this.scrollbarHeight - this.scrollBarTop) / (this.scrollHeight) + this.scrollBarTop;
            console.log("up:" + this.scrollY + ",top=" + y)
            $(".scrollBox").animate({ top: this.scrollY }, 100)

            $(".scrollbar").animate({ top: y }, 100, () => {
                let top = this.getTop()
                console.log("scrollbar top:" + top + ",showMask:" + this.state.isTop)
                if (top <= this.scrollBarTop && this.state.showMask) {
                    this.setState(prevState => ({ ...prevState, showMask: false }))
                }
            });
        }
    }

    getTop = () => {
        return this.scrollBar.offsetTop;
    }

    render() {
        return (<div className="scrollBox" id="scrollBox">

            <div className={this.state.showMask ? "topMask show" : "topMask hide"}></div>

            <div className="scrollbar" id="scrollbar"></div>

            {this.props.children}
        </div>);
    }
}


// WEBPACK FOOTER //
// ./src/component/ScrollView.js